module.exports = __webpack_public_path__ + "img/icon43.97e0aecc.png";